import React from 'react';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { useNavigate } from 'react-router-dom';
import { useJobs } from 'src/hooks/useJobs';
import { useAuth } from 'src/hooks/useAuth';
import { Header } from 'src/design/organisms/Header';
import { jobBreadcrumbs } from 'src/app/workflows/jobBreadcrumbs';
import { TransmittalDto } from 'src/api/FiretrolApiClient';
import {
  TransmittalForm,
  TransmittalFormValues,
} from 'src/routes/Jobs/Transmittals/components/TransmittalForm';

const emptyTransmittal: Partial<TransmittalDto> = {
  title: '',
  notes: '',
  assignee: undefined,
  transmittalNumber: '',
  status: '',
  workflow: undefined,
  assigneeUserId: undefined,
  submittedToContactId: undefined,
  submittedToContact: undefined,
  stepIndex: -1,
  documents: [],
  id: '',
  history: [],
};

export const SubmitTransmittal: React.FC = () => {
  const { selectedJob } = useJobs();
  const { user } = useAuth();
  const navigate = useNavigate();
  const initialValues: TransmittalFormValues = React.useMemo(() => {
    return {
      ...emptyTransmittal,
      jobId: selectedJob?.id || -1,
      workflowId: selectedJob ? selectedJob.transmittalWorkflowId : 0,
      workflow: selectedJob?.transmittalWorkflow ?? undefined,
      fromUserId: user?.id || -1,
      fromUser: user || undefined,
      externalContact: null,
      filesToAdd: [],
      filesToRemove: [],
    } as TransmittalFormValues;
  }, [selectedJob?.transmittalWorkflow, user?.id]);

  if (!selectedJob) return null;
  return (
    <>
      <Header
        title="Create Transmittal"
        breadcrumbProps={{
          items: jobBreadcrumbs(
            selectedJob,
            {
              text: 'Transmittals',
              href: `/jobs/${selectedJob.id}/transmittals`,
            },
            'Create Transmittal',
          ),
        }}
        helpText="Create a new transmittal to send documents for this job."
        actions={
          <BasicButton
            variant="default"
            onClick={() => navigate(`/jobs/${selectedJob.id}/transmittals`)}
          >
            Cancel
          </BasicButton>
        }
      />
      <TransmittalForm
        initialValues={initialValues}
        selectedJob={selectedJob}
        onCreated={(transmittal) =>
          navigate(`/jobs/${selectedJob.id}/transmittals/${transmittal.id}`)
        }
      />
    </>
  );
};
